import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import {
    tabularPropertiesCommonAdapts,
    TabularTypeDatasetAdapter
} from './tabular-type.dataset.adapter';
import { ConnectionKind, IModel, SnowflakeTableDataset } from 'shell-models-lib';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

export const snowflakeTableDatasetAdapter = {
    ...tabularPropertiesCommonAdapts,
    typeProperties: {
        tableName: '*',
        schema: '*',
        table: '*',
        database: __IS_FABRIC_DPE__ ? '*' : undefined
    }
};
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SnowflakeTableDataset),
    asynchronous: true,
    disabled: __IS_FABRIC_DPE__,
    adapts: {
        name: '*',
        properties: snowflakeTableDatasetAdapter
    }
})
export class SnowflakeTableDatasetAdapter extends TabularTypeDatasetAdapter<
    SnowflakeTableDataset,
    Model.DatasetResource
> {
    protected model(): IModel {
        return SnowflakeTableDataset.MODEL;
    }

    protected async _toResource(dataset: SnowflakeTableDataset): Promise<Model.DatasetResource> {
        const modelDataset = await this._toResourceInternal(dataset, this.model().name);
        if (
            (__IS_FABRIC_DPE__ && dataset.linkedService.tridentConnectionKind === ConnectionKind.SNOWFLAKE)
                || this.context.adapterConfig.convertToFabric
        ) {
            modelDataset.properties.typeProperties.database = ValueAdapter.toResource(
                dataset,
                SnowflakeTableDataset.DATABASE
            );
        }
        return modelDataset;
    }

    protected async _toModel(
        modelDatasetResource: Model.DatasetResource,
        dataset?: SnowflakeTableDataset
    ): Promise<SnowflakeTableDataset> {
        dataset = await this._toModelInternal(modelDatasetResource, dataset, this.model());
        if (modelDatasetResource.properties?.typeProperties) {
            ValueAdapter.toModel(
                dataset,
                SnowflakeTableDataset.DATABASE,
                modelDatasetResource.properties.typeProperties.database
            );
        }
        return dataset;
    }
}
